// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4b78bfb6","455":"9f311ace","488":"1de1f096","644":"eafc67c8"}[chunkId] + ".chunk.js";
};